// 学员端-查询父分类下的子分类列表-数组
export const getStuCategoryData = (data, apiInstance) => {
  return apiInstance.post('api/utree/node/list/by-pnode-id', data);
};

// 管理端查询父分类下的子分类数据---数组
export const getManageCategoryData = (data, apiInstance) => {
  return apiInstance.post('api/mgr/utree/node/list/by-pnode-id', data);
};

// 分类详情
export const getNodeDeatil = (data, apiInstance) => {
  return apiInstance.get('api/mgr/utree/node/detail/by-node-id', data);
};
